import { LicenseType } from '../services/api/api'

export const getLicenseLabel = (
  licenseId: string | null | undefined,
  licenseTypes: LicenseType[]
): string => {
  if (!licenseId || !licenseTypes.length) return '-'
  
  const licenseType = licenseTypes.find(type => type.id === licenseId)
  return licenseType?.code || '-'
}

export const getLicenseType = (
  licenseId: string | null | undefined,
  licenseTypes: LicenseType[]
): string => {
  return getLicenseLabel(licenseId, licenseTypes)
}

export const getLicenseName = (
  licenseId: string | null | undefined,
  licenseTypes: LicenseType[]
): string => {
  if (!licenseId || !licenseTypes.length) return '-'
  
  const licenseType = licenseTypes.find(type => type.id === licenseId)
  return licenseType?.name || '-'
}

export const getLicenseByCode = (
  code: string,
  licenseTypes: LicenseType[]
): LicenseType | undefined => {
  return licenseTypes.find(type => type.code === code)
}

export const getLicenseById = (
  id: string,
  licenseTypes: LicenseType[]
): LicenseType | undefined => {
  return licenseTypes.find(type => type.id === id)
}

export const isValidLicenseId = (
  licenseId: string,
  licenseTypes: LicenseType[]
): boolean => {
  return licenseTypes.some(type => type.id === licenseId)
}

// Export types for backwards compatibility and usage
export type { LicenseType } from '../services/api/api' 